<template>
  <div class="card" style="margin-bottom: 10px;">
      <div class="cardBody">
        <div class="cardContent">
          <div style="display: flex; flex-direction: row; width: 100%; justify-content: flex-start; align-items: flex-start;">
            <p class="cardTitleType1">{{ tajukKad }}</p>
          </div>
          <div style="display: flex; flex-direction: column; width: 100%; justify-content: flex-start; align-items: flex-start;">
            <p style="margin-bottom: 0px; font-weight: bold;">Kuota Subsidi Semasa Bulan : FEBRUARI</p>
            <p style="margin-bottom: 0px;">Jumlah Kuota Bulan (Semasa) : <span style="font-weight: bold;">{{ kenderaanKuotaAsa }} Liter</span></p>
            <div style="display: flex; flex-direction: row; justify-content: flex-start; align-items: center; width: 100%; margin-top: 10px;">
              <p style="font-weight: bold; margin-top: 0px; margin-bottom: 0px; margin-right: 10px;">Carian No. Pendaftaran Kenderaan:</p>
              <el-input
                style="width: 240px;"
                v-model="searchKenderaan">
              </el-input>
              <div v-if="tambahAllowed" style="display: flex; flex-direction: row; justify-content: flex-end; align-items: center; flex: 1;">
                <el-button style="padding: 12px 24px;" @click="()=>{}" type="primary">
                  <i class="el-icon-plus" style="margin-right: 5px;"/> Tambah
                </el-button>
              </div>
            </div>
            <div style="display: flex; width: 100%; justify-content: flex-start; align-items: flex-start; overflow: scroll; transform: rotateX(180deg); margin-top: 10px;">
              <div style="transform: rotateX(180deg);">
                <table class="tableBordered" style="margin-top: 0px;">
                  <tbody>
                    <tr>
                      <th style="width: 80px;">Bil.</th>
                      <th style="width: 120px;">No. Pendaftaran Kenderaan</th>
                      <th style="width: 240px;">Jenis Kenderaan</th>
                      <th style="width: 120px;">Sektor Pengangkutan</th>
                      <th style="width: 120px;">Jenis Penggunaan</th>
                      <th style="width: 120px;">Tarikh Tamat Cukai Jalan</th>
                      <th style="width: 120px;">Tarikh Tamat Permit</th>
                      <th style="width: 120px;">Tarikh Permohonan</th>
                      <th style="width: 120px;">Kuota Asas (Liter)</th>
                      <th style="width: 120px;">Kuota Semasa (Liter)</th>
                    </tr>
                    <tr v-for="(item, key) in kenderaanArray" :key="key">
                      <td>{{ key + 1 }}</td>
                      <td>{{ item.noPendaftaranKenderaan }}</td>
                      <td>{{ item.jenisKenderaan }}</td>
                      <td>{{ item.sektorPengangkutan }}</td>
                      <td>{{ item.jenisPenggunaan }}</td>
                      <td>{{ item.tarikhTamatCukaiJalan }}</td>
                      <td>{{ item.tarikhTamatPermit }}</td>
                      <td>{{ item.tarikhPermohonan }}</td>
                      <td>{{ item.kuotaAsas | formatNumber }}</td>
                      <td>{{ item.kuotaSemasa | formatNumber }}</td>
                    </tr>
                    <tr>
                      <td colspan="8" align="right"><b>JUMLAH KUOTA SAH (Liter)</b></td>
                      <td>{{ kenderaanKuotaAsa }}</td>
                      <td>{{ kenderaanKuotaSemasa }}</td>
                    </tr>
                    <tr>
                      <td colspan="8" align="right"><b>JUMLAH KUOTA TIDAK SAH (Liter)</b></td>
                      <td style="color:red;"><b>0</b></td>
                      <td style="color:red;"><b>0</b></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
export default {
  name: 'senarai-kenderaan-diesel',
  inheritAttrs: false,
  data() {
    return {
      faqQuestionOpened: false
    }
  },
  methods: {
    openFaqQuestion() {
      this.faqQuestionOpened = !this.faqQuestionOpened
    }
  },
  props: {
    titleFaqQuestion: {
      type: String
    },
    descFaqQuestion: {
      type: String
    },
    tajukKad: {
      type: String
    },
    kenderaanArray: {
      type: Array
    },
    searchKenderaan: {
      type: String
    },
    tambahAllowed: {
      type: Boolean
    }
  },
  filters: {
    formatNumber(val) {
      if (val !== null && val !== undefined) {
        return val.toLocaleString('en')
      }
      return '-'
    },
  },
  computed: {
    kenderaanKuotaAsa() {
      return Number(this.kenderaanArray.reduce((acc, item) => acc + item.kuotaAsas, 0)).toLocaleString('en')
    },
    kenderaanKuotaSemasa() {
      return Number(this.kenderaanArray.reduce((acc, item) => acc + item.kuotaSemasa, 0)).toLocaleString('en')
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/mydiesel/components/SenaraiKenderaanDiesel.vue